import { Component, Input } from '@angular/core';
import { ApplicationRecord } from '../../interfaces/application-record.interface';
import { SAVE_QUOTE_DOCUMENT_UPLOAD_HANDOFF_STATUS } from '../../saved-quotes/interfaces/save-quote-data.interface';
import { SAVE_QUOTE_CARD_TYPE, SavedQuotesInputs } from '../../saved-quotes/interfaces/saved-quotes.input.interface';
import { SavedQuotesDocumentUploadUtilityService } from '../../saved-quotes/services/saved-quotes-document-upload-utility.service';

@Component({
  selector: 'app-sep-document-upload-status-indicator',
  templateUrl: './sep-document-upload-status-indicator.component.html',
  styleUrl: './sep-document-upload-status-indicator.component.scss',
  standalone: false
})
export class SepDocumentUploadStatusIndicatorComponent {

  @Input() applicationRecord: ApplicationRecord;
  @Input() quoteType: SavedQuotesInputs["TQuoteType"];

  constructor(private savedQuotesDocumentUploadUtilityService: SavedQuotesDocumentUploadUtilityService) {}
  
  get documentUploadSEPStatus(): SAVE_QUOTE_DOCUMENT_UPLOAD_HANDOFF_STATUS {
    return this.savedQuotesDocumentUploadUtilityService.getDocumentUploadSEPStatus(this.applicationRecord);
  }

  get displayDocumentUploadIndicator(): boolean {
    return this.savedQuotesDocumentUploadUtilityService.getDisplayDocumentUploadIndicator(
      this.applicationRecord,
      this.quoteType
    )
  }
}
